module.exports = __webpack_public_path__ + "media/Insects.a2707572.ogg";